import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
// Import Global Components
import Button from '../Button';
// Import Hooks
import { CARD_REPLACEMENT_STATES } from '../../hooks/useCardReplacement';

// The header's primary action, as in the mockup. Offered whenever the program has replacement on; kept in place but disabled while a
// replacement is on the way, so a second order cannot be started.
const ReplaceCardButton = ({ state, onClick, size }) => {
  const intl = useIntl();

  if (state === CARD_REPLACEMENT_STATES.NONE) return null;

  const inProgress = state === CARD_REPLACEMENT_STATES.IN_PROGRESS;

  return (
    <Button
      buttonText={intl.messages['replace-card-button']}
      page="replace"
      buttonFor="card"
      type="primary"
      size={size}
      disabled={inProgress}
      title={inProgress ? intl.messages['replace-card-in-progress-title'] : undefined}
      onClick={onClick}
    />
  );
};

ReplaceCardButton.propTypes = {
  state: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.string,
};

ReplaceCardButton.defaultProps = {
  size: undefined,
};

export default ReplaceCardButton;
